module.exports = "/assets/b094c50bb7cea5d644d9d8c0c04ae365.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/QB.png
// module id = 1745
// module chunks = 0